import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { BsActivity } from "react-icons/bs";
import ActivityFeed from '../ActivityFeed';

export default function ActivityModal({ ticket }) {
    const [show, setShow]         = useState(false);
    const refContainerList        = useRef(null);

    const handleClose = () => setShow(false);
    const handleShow  = () => setShow(true);

    return (
        <>
            <style>{`
                .act-modal .modal-dialog { max-width: 580px }
                .act-modal .modal-body   { padding: 0 !important; background: #f8f9fa; }
            `}</style>

            <Button variant="secondary" size="sm" className="ms-auto me-1" onClick={handleShow}>
                <BsActivity /> Ticket Activity
            </Button>

            <Modal className="act-modal left-aligned-modal" show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton style={{ borderBottom: '2px solid #dee2e6' }}>
                    <Modal.Title style={{ fontSize: '14px', fontWeight: 700 }}>
                        <BsActivity className="me-2 text-secondary" /> Ticket Activity
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body ref={refContainerList} style={{ height: '70vh', overflowY: 'auto' }}>
                    {show && (
                        <ActivityFeed ticketId={ticket.id} containerRef={refContainerList} />
                    )}
                </Modal.Body>

                <Modal.Footer style={{ borderTop: '2px solid #dee2e6' }}>
                    <Button variant="secondary" size="sm" onClick={handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
